import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  errorMessage = '';
  isLoading = false;
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  isInvalid(controlName: 'username' | 'password'): boolean {
    const c = this.loginForm.get(controlName);
    return !!c && c.invalid && (c.touched || c.dirty);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    if (this.isLoading) return;

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    const { username, password } = this.loginForm.value;
    const credentials = {
      username: (username ?? '').trim(),
      password: password ?? '',
    };

    this.authService.login(credentials).subscribe({
      next: () => {
        this.isLoading = false;
        this.toastService.success('Вы успешно вошли в систему');
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.isLoading = false;

        const message =
          err?.status === 401
            ? 'Неверное имя пользователя или пароль'
            : 'Не удалось войти. Попробуйте позже';

        this.errorMessage = message;
        this.toastService.error(message);
      },
    });
  }
}
